// TODO: Delete Shared/status.js and rename this to Shared/status.js after
// GUIDE_JS is converted to webpack.
export default function setupStatuses() {
   $$('.js-status-cancel').each(el => {
      const notification = el.getParent();
      const container = notification.getParent();

      function clearNotification() {
         if (container.getChildren().length <= 1) {
            container.dispose();
         } else {
            notification.dispose();
         }
      }

      el.addEvent('click', clearNotification);
   });
}
